/* eslint-disable react/prop-types */
export const LogoIcon = props => (
    <svg
        {...props}
        width="128"
        height="31"
        viewBox="0 0 128 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_319_1390)">
            <path
                d="M60 5.5C65.5229 5.5 70 9.97715 70 15.5C70 21.0228 65.5229 25.5 60 25.5C57.7486 25.5 55.671 24.756 53.9996 23.5004L54 30.5H50V5.5L52.9289 8.42893C54.7386 6.61929 57.2386 5.5 60 5.5ZM32.7667 0.5L38.786 11.786L43.5001 5.5H48.4999L40.862 15.682L48.7667 30.5H44.2333L38.214 19.214L33.5001 25.5H28.5001L36.136 15.32L28.2333 0.5H32.7667ZM118 5.5C123.523 5.5 128 9.97715 128 15.5V25.5H124V15.5C124 12.1863 121.314 9.5 118 9.5C114.686 9.5 112 12.1863 112 15.5V25.5H108V5.5L110.929 8.42893C112.739 6.61929 115.239 5.5 118 5.5ZM105 5.5V25.5H101V5.5H105ZM98 5.5V25.5L95.0711 22.5711C93.2614 24.3807 90.7614 25.5 88 25.5C82.4771 25.5 78 21.0228 78 15.5C78 9.97715 82.4771 5.5 88 5.5C90.7624 5.5 93.2632 6.6201 95.073 8.43089L98 5.5ZM76 0.5V25.5H72V0.5H76ZM27 5.5V25.5H23V5.5H27ZM20 5.5V25.5L17.0711 22.5711C15.2614 24.3807 12.7614 25.5 10 25.5C4.47715 25.5 0 21.0228 0 15.5C0 9.97715 4.47715 5.5 10 5.5C12.7624 5.5 15.2632 6.6201 17.073 8.43089L20 5.5ZM88 9.5C84.6863 9.5 82 12.1863 82 15.5C82 18.8137 84.6863 21.5 88 21.5C91.3137 21.5 94 18.8137 94 15.5C94 12.1863 91.3137 9.5 88 9.5ZM60 9.5C56.6863 9.5 54 12.1863 54 15.5C54 18.8137 56.6863 21.5 60 21.5C63.3137 21.5 66 18.8137 66 15.5C66 12.1863 63.3137 9.5 60 9.5ZM10 9.5C6.68629 9.5 4 12.1863 4 15.5C4 18.8137 6.68629 21.5 10 21.5C13.3137 21.5 16 18.8137 16 15.5C16 12.1863 13.3137 9.5 10 9.5ZM105 0.5V3.5H101V0.5H105ZM27 0.5V3.5H23V0.5H27Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_319_1390">
                <rect
                    width="128"
                    height="30"
                    fill="white"
                    transform="translate(0 0.5)"
                />
            </clipPath>
        </defs>
    </svg>
)

export const ChatIconDots = props => (
    <svg
        {...props}
        width="32"
        height="33"
        viewBox="0 0 32 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M18.6665 25.8333C23.6945 25.8333 26.2092 25.8333 27.7705 24.2707C29.3332 22.7093 29.3332 20.1947 29.3332 15.1667C29.3332 10.1387 29.3332 7.624 27.7705 6.06267C26.2092 4.5 23.6945 4.5 18.6665 4.5H13.3332C8.30517 4.5 5.7905 4.5 4.22917 6.06267C2.6665 7.624 2.6665 10.1387 2.6665 15.1667C2.6665 20.1947 2.6665 22.7093 4.22917 24.2707C5.09984 25.1427 6.2665 25.528 7.99984 25.6973"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.9998 15.1667V15.18M10.6665 15.1667V15.18M21.3332 15.1667V15.18M18.6665 25.8333C17.0185 25.8333 15.2025 26.5 13.5452 27.36C10.8812 28.7427 9.54917 29.4347 8.89317 28.9933C8.23717 28.5533 8.36117 27.1867 8.6105 24.4547L8.6665 23.8333"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
        />
    </svg>
)

export const SendIcon = ({ fill = '#AFB3B6', ...props }) => (
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
    >
        <path
            d="M20.34 9.32001L6.34 2.32001C5.78749 2.04502 5.16362 1.94712 4.55344 2.03966C3.94326 2.1322 3.37646 2.41068 2.93033 2.83712C2.48421 3.26357 2.18046 3.81723 2.0605 4.42262C1.94054 5.02801 2.0102 5.65566 2.26 6.22001L4.66 11.59C4.71446 11.7198 4.74251 11.8592 4.74251 12C4.74251 12.1408 4.71446 12.2802 4.66 12.41L2.26 17.78C2.0567 18.2367 1.97076 18.737 2.00998 19.2354C2.0492 19.7337 2.21235 20.2144 2.48459 20.6337C2.75682 21.053 3.12953 21.3976 3.56883 21.6362C4.00812 21.8748 4.50009 21.9999 5 22C5.46823 21.9953 5.92949 21.886 6.35 21.68L20.35 14.68C20.8466 14.4302 21.264 14.0473 21.5557 13.5741C21.8474 13.1009 22.0018 12.5559 22.0018 12C22.0018 11.4441 21.8474 10.8992 21.5557 10.4259C21.264 9.9527 20.8466 9.56982 20.35 9.32001H20.34ZM19.45 12.89L5.45 19.89C5.26617 19.9783 5.05973 20.0082 4.85839 19.9759C4.65705 19.9435 4.47041 19.8503 4.32352 19.7089C4.17662 19.5674 4.07648 19.3844 4.03653 19.1844C3.99658 18.9845 4.01873 18.777 4.1 18.59L6.49 13.22C6.52094 13.1483 6.54766 13.0748 6.57 13H13.46C13.7252 13 13.9796 12.8946 14.1671 12.7071C14.3546 12.5196 14.46 12.2652 14.46 12C14.46 11.7348 14.3546 11.4804 14.1671 11.2929C13.9796 11.1054 13.7252 11 13.46 11H6.57C6.54766 10.9252 6.52094 10.8517 6.49 10.78L4.1 5.41001C4.01873 5.22297 3.99658 5.01556 4.03653 4.81558C4.07648 4.6156 4.17662 4.43261 4.32352 4.29115C4.47041 4.1497 4.65705 4.05654 4.85839 4.02416C5.05973 3.99178 5.26617 4.02174 5.45 4.11001L19.45 11.11C19.6138 11.1939 19.7513 11.3214 19.8473 11.4785C19.9433 11.6355 19.994 11.816 19.994 12C19.994 12.1841 19.9433 12.3645 19.8473 12.5216C19.7513 12.6786 19.6138 12.8061 19.45 12.89Z"
            fill={fill}
        />
    </svg>
)
export const StarsIcon = ({ fill = 'white', ...props }) => (
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="26"
        viewBox="0 0 20 26"
        fill="none"
    >
        <path
            d="M10.8189 10.149C10.9977 9.61273 11.755 9.61273 11.9337 10.149L12.9818 13.2966C13.2125 13.9886 13.6012 14.6172 14.1171 15.1328C14.633 15.6485 15.2619 16.0368 15.954 16.2671L19.1 17.3153C19.6362 17.494 19.6362 18.2513 19.1 18.43L15.9523 19.4781C15.2604 19.7089 14.6317 20.0976 14.1161 20.6134C13.6005 21.1293 13.2122 21.7582 12.9818 22.4503L11.9337 25.5963C11.8952 25.7137 11.8205 25.816 11.7204 25.8885C11.6203 25.961 11.4999 26 11.3763 26C11.2527 26 11.1323 25.961 11.0322 25.8885C10.9321 25.816 10.8575 25.7137 10.8189 25.5963L9.77082 22.4487C9.54028 21.7569 9.15182 21.1283 8.63623 20.6127C8.12063 20.0971 7.49206 19.7087 6.80031 19.4781L3.65267 18.43C3.53524 18.3915 3.43299 18.3168 3.36049 18.2168C3.288 18.1167 3.24897 17.9962 3.24897 17.8726C3.24897 17.7491 3.288 17.6286 3.36049 17.5285C3.43299 17.4284 3.53524 17.3538 3.65267 17.3153L6.80031 16.2671C7.49206 16.0366 8.12063 15.6481 8.63623 15.1325C9.15182 14.6169 9.54028 13.9884 9.77082 13.2966L10.8189 10.149ZM4.54155 1.86307C4.56485 1.7927 4.60974 1.73146 4.66983 1.68806C4.72993 1.64466 4.80217 1.62129 4.8763 1.62129C4.95043 1.62129 5.02267 1.64466 5.08277 1.68806C5.14286 1.73146 5.18775 1.7927 5.21105 1.86307L5.83993 3.75133C6.12105 4.59309 6.78081 5.25284 7.62256 5.53397L9.51082 6.16284C9.58119 6.18614 9.64243 6.23103 9.68583 6.29113C9.72924 6.35122 9.7526 6.42346 9.7526 6.49759C9.7526 6.57172 9.72924 6.64397 9.68583 6.70406C9.64243 6.76416 9.58119 6.80904 9.51082 6.83235L7.62256 7.46122C7.20741 7.59954 6.83018 7.83264 6.52076 8.14206C6.21135 8.45148 5.97824 8.82871 5.83993 9.24386L5.21105 11.1321C5.18775 11.2025 5.14286 11.2637 5.08277 11.3071C5.02267 11.3505 4.95043 11.3739 4.8763 11.3739C4.80217 11.3739 4.72993 11.3505 4.66983 11.3071C4.60974 11.2637 4.56485 11.2025 4.54155 11.1321L3.91267 9.24386C3.77435 8.82871 3.54125 8.45148 3.23183 8.14206C2.92242 7.83264 2.54519 7.59954 2.13004 7.46122L0.24178 6.83235C0.171408 6.80904 0.11017 6.76416 0.0667656 6.70406C0.0233617 6.64397 0 6.57172 0 6.49759C0 6.42346 0.0233617 6.35122 0.0667656 6.29113C0.11017 6.23103 0.171408 6.18614 0.24178 6.16284L2.13004 5.53397C2.54519 5.39565 2.92242 5.16255 3.23183 4.85313C3.54125 4.54371 3.77435 4.16648 3.91267 3.75133L4.54155 1.86307ZM16.0287 0.158442C16.0448 0.112172 16.0748 0.0720505 16.1147 0.0436546C16.1546 0.0152587 16.2024 0 16.2513 0C16.3003 0 16.3481 0.0152587 16.388 0.0436546C16.4279 0.0720505 16.4579 0.112172 16.474 0.158442L16.8932 1.4162C17.0801 1.97845 17.5205 2.41883 18.0827 2.6057L19.3405 3.02495C19.3868 3.041 19.4269 3.07106 19.4553 3.11095C19.4837 3.15085 19.4989 3.19861 19.4989 3.24758C19.4989 3.29655 19.4837 3.34431 19.4553 3.38421C19.4269 3.4241 19.3868 3.45416 19.3405 3.47021L18.0827 3.88946C17.8056 3.98163 17.5539 4.13714 17.3474 4.34362C17.1409 4.5501 16.9854 4.80188 16.8932 5.07896L16.474 6.33672C16.4579 6.38299 16.4279 6.42311 16.388 6.45151C16.3481 6.4799 16.3003 6.49516 16.2513 6.49516C16.2024 6.49516 16.1546 6.4799 16.1147 6.45151C16.0748 6.42311 16.0448 6.38299 16.0287 6.33672L15.6095 5.07896C15.5173 4.80188 15.3618 4.5501 15.1553 4.34362C14.9488 4.13714 14.697 3.98163 14.42 3.88946L13.1638 3.47021C13.1176 3.45416 13.0774 3.4241 13.049 3.38421C13.0206 3.34431 13.0054 3.29655 13.0054 3.24758C13.0054 3.19861 13.0206 3.15085 13.049 3.11095C13.0774 3.07106 13.1176 3.041 13.1638 3.02495L14.4216 2.6057C14.9838 2.41883 15.4242 1.97845 15.6111 1.4162L16.0287 0.160067V0.158442Z"
            fill={fill}
        />
    </svg>
)

export const AlertIcon = ({ stroke = '#DF1642', fill = 'none', ...props }) => (
    <svg {...props} viewBox="0 0 24 24" height={'24px'} width={'24px'}>
        <circle
            cx="12"
            cy="12"
            r="11"
            stroke={stroke}
            fill={fill}
            strokeWidth="2"
        />
        <path
            stroke={stroke}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 7v5M12 16v.5"
        />
    </svg>
)

export const AlertIconBanner = (props = {}) => (
    <svg {...props} viewBox="0 0 24 24" height={'24px'}>
        <circle cx="12" cy="12" r="12" fill="#fff" />
        <path
            fill="#ED746F"
            d="M12.606 4.618c-.237-.443-.975-.443-1.212 0l-6.171 11.53a.672.672 0 00.268.907c.103.058.22.088.338.088h12.342a.69.69 0 00.588-.328.671.671 0 00.018-.667l-6.17-11.53zm.08 10.49h-1.371v-1.356h1.371v1.356zm-1.371-2.712V9.005h1.371v3.39h-1.371z"
        />
    </svg>
)

export const DoneIcon = (props = {}) => (
    <svg
        viewBox="0 0 50 50"
        height="24px"
        width="24px"
        {...props}
        fill="#18A957"
    >
        <path d="M18.9 35.7 7.7 24.5 9.85 22.35 18.9 31.4 38.1 12.2 40.25 14.35Z" />
    </svg>
)

export const TwitchIcon = ({ ...props }) => (
    <svg
        {...props}
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M6.50869 0L1.6875 4.82119V22.1788H7.47394V27L12.2951 22.1788H16.1494L24.8299 13.5V0H6.50869ZM22.9011 12.5364L19.0451 16.3924H15.1875L11.8125 19.7674V16.3924H7.47394V1.92881H22.9011V12.5364Z"
            fill="black"
        />
        <path
            d="M20.0087 5.30322H18.0799V11.0863H20.0087V5.30322ZM14.7049 5.30322H12.7761V11.0863H14.7049V5.30322Z"
            fill="black"
        />
    </svg>
)

export const QuestionMarkIcon = (props = {}) => (
    <svg
        {...props}
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M10.6907 16.446C11.0407 16.446 11.3366 16.3252 11.5782 16.0835C11.8199 15.8419 11.9407 15.546 11.9407 15.196C11.9407 14.846 11.8199 14.5502 11.5782 14.3085C11.3366 14.0669 11.0407 13.946 10.6907 13.946C10.3407 13.946 10.0449 14.0669 9.80322 14.3085C9.56156 14.5502 9.44072 14.846 9.44072 15.196C9.44072 15.546 9.56156 15.8419 9.80322 16.0835C10.0449 16.3252 10.3407 16.446 10.6907 16.446ZM9.79072 12.596H11.6407C11.6407 12.046 11.7032 11.6127 11.8282 11.296C11.9532 10.9794 12.3074 10.546 12.8907 9.99605C13.3241 9.56271 13.6657 9.15021 13.9157 8.75854C14.1657 8.36688 14.2907 7.89605 14.2907 7.34605C14.2907 6.41271 13.9491 5.69604 13.2657 5.19604C12.5824 4.69604 11.7741 4.44604 10.8407 4.44604C9.89072 4.44604 9.11989 4.69604 8.52822 5.19604C7.93656 5.69604 7.52406 6.29605 7.29072 6.99605L8.94072 7.64605C9.02406 7.34605 9.21156 7.02104 9.50322 6.67104C9.79489 6.32104 10.2407 6.14605 10.8407 6.14605C11.3741 6.14605 11.7741 6.29188 12.0407 6.58355C12.3074 6.87521 12.4407 7.19604 12.4407 7.54604C12.4407 7.87938 12.3407 8.19188 12.1407 8.48355C11.9407 8.77521 11.6907 9.04605 11.3907 9.29605C10.6574 9.94604 10.2074 10.4377 10.0407 10.771C9.87406 11.1044 9.79072 11.7127 9.79072 12.596ZM10.7407 20.446C9.35739 20.446 8.05739 20.1835 6.84072 19.6585C5.62406 19.1335 4.56572 18.421 3.66572 17.521C2.76572 16.621 2.05322 15.5627 1.52822 14.346C1.00322 13.1294 0.740723 11.8294 0.740723 10.446C0.740723 9.06271 1.00322 7.76271 1.52822 6.54604C2.05322 5.32938 2.76572 4.27104 3.66572 3.37104C4.56572 2.47104 5.62406 1.75854 6.84072 1.23354C8.05739 0.708545 9.35739 0.446045 10.7407 0.446045C12.1241 0.446045 13.4241 0.708545 14.6407 1.23354C15.8574 1.75854 16.9157 2.47104 17.8157 3.37104C18.7157 4.27104 19.4282 5.32938 19.9532 6.54604C20.4782 7.76271 20.7407 9.06271 20.7407 10.446C20.7407 11.8294 20.4782 13.1294 19.9532 14.346C19.4282 15.5627 18.7157 16.621 17.8157 17.521C16.9157 18.421 15.8574 19.1335 14.6407 19.6585C13.4241 20.1835 12.1241 20.446 10.7407 20.446ZM10.7407 18.446C12.9741 18.446 14.8657 17.671 16.4157 16.121C17.9657 14.571 18.7407 12.6794 18.7407 10.446C18.7407 8.21271 17.9657 6.32105 16.4157 4.77105C14.8657 3.22105 12.9741 2.44604 10.7407 2.44604C8.50739 2.44604 6.61572 3.22105 5.06572 4.77105C3.51572 6.32105 2.74072 8.21271 2.74072 10.446C2.74072 12.6794 3.51572 14.571 5.06572 16.121C6.61572 17.671 8.50739 18.446 10.7407 18.446Z"
            fill="white"
        />
    </svg>
)

export const CloseIcon = (props = {}) => (
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        fill="none"
        viewBox="0 0 14 14"
    >
        <path
            fill="white"
            d="M7 5.586l4.95-4.95 1.414 1.414L8.414 7l4.95 4.95-1.414 1.414L7 8.414l-4.95 4.95L.636 11.95 5.586 7 .636 2.05 2.05.636 7 5.586z"
        ></path>
    </svg>
)

export const FullscreenIcon = (props = {}) => (
    <svg
        {...props}
        width="20"
        height="20"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M24 13H19V8"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M26 6L19 13"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8 19H13V24"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6 26L13 19"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M19 24V19H24"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M26 26L19 19"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13 8V13H8"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6 6L13 13"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const ExpandIcon = (props = {}) => (
    <svg
        {...props}
        width="20"
        height="20"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M21 6H26V11"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M19 13L26 6"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11 26H6V21"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13 19L6 26"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M26 21V26H21"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M19 19L26 26"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6 11V6H11"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13 13L6 6"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const CopyIcon = (props = {}) => (
    <svg
        {...props}
        version="1.0"
        width="512.000000pt"
        height="512.000000pt"
        viewBox="0 0 512.000000 512.000000"
        preserveAspectRatio="xMidYMid meet"
    >
        <g
            transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            fill="#fff"
            stroke="none"
        >
            <path
                d="M1622 5109 c-47 -14 -109 -79 -123 -131 -23 -89 12 -182 88 -229 l38
-24 1191 -5 1190 -5 76 -37 c91 -45 147 -103 191 -196 l32 -67 5 -1590 5
-1590 24 -38 c13 -21 42 -50 64 -65 34 -23 52 -27 107 -27 55 0 73 4 107 27
22 15 51 44 64 65 l24 38 0 1605 c0 1468 -1 1610 -17 1665 -43 157 -109 273
-213 378 -68 70 -184 148 -263 177 -156 59 -61 55 -1362 57 -740 1 -1208 -2
-1228 -8z"
            />
            <path
                d="M1050 4295 c-337 -69 -587 -329 -639 -665 -9 -55 -11 -452 -9 -1520
3 -1575 -1 -1455 58 -1612 66 -177 261 -372 438 -438 154 -58 82 -55 1257 -55
1175 0 1103 -3 1257 55 178 66 372 260 438 438 59 156 55 43 55 1657 0 1351
-1 1485 -17 1540 -43 157 -109 273 -213 378 -68 70 -184 148 -263 177 -155 58
-74 55 -1232 57 -851 1 -1078 -1 -1130 -12z m2222 -422 c93 -44 151 -100 196
-191 l37 -76 0 -1451 0 -1451 -37 -76 c-45 -91 -103 -147 -196 -191 l-67 -32
-1050 0 -1050 0 -67 32 c-93 44 -151 100 -196 191 l-37 76 0 1450 0 1451 32
67 c17 37 50 87 72 111 44 48 135 101 197 116 23 5 468 9 1069 8 l1030 -2 67
-32z"
            />
        </g>
    </svg>
)

export const MicIcon = (props = {}) => (
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 -960 960 960"
        fill={props.fill}
        cursor={props.cursor || 'pointer'}
    >
        <path d="M480-400q-50 0-85-35t-35-85v-240q0-50 35-85t85-35q50 0 85 35t35 85v240q0 50-35 85t-85 35zm0-240zm-40 520v-123q-104-14-172-93t-68-184h80q0 83 58.5 141.5T480-320q83 0 141.5-58.5T680-520h80q0 105-68 184t-172 93v123h-80zm40-360q17 0 28.5-11.5T520-520v-240q0-17-11.5-28.5T480-800q-17 0-28.5 11.5T440-760v240q0 17 11.5 28.5T480-480z"></path>
    </svg>
)

export const PlayIcon = (props = {}) => (
    <svg
        {...props}
        width="24"
        height="24"
        viewBox="0 -960 960 960"
        fill={'white'}
    >
        <path d="M380-300l280-180-280-180v360zM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93zm0-320z"></path>
    </svg>
)
